// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__BsID3","title":"Header_title__kH6SG","left":"Header_left__1a5DY","clinicName":"Header_clinicName__DVnvV"};